import Modal from "./Modal.jsx";
export default Modal;